import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import { FaArrowLeft } from 'react-icons/fa';

const SubeShifarasList = () => {
    const navigate = useNavigate();
    const [works, setWorks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedTaluka, setSelectedTaluka] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const talukas = [
        "कल्याण", "शहापूर", "मुरबाड", "भिवंडी", "अंबरनाथ"
    ];

    const fetchWorks = () => {
        setLoading(true);
        const worksRef = ref(db, 'ekamwatapzp/generatework');
        onValue(worksRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                let list = [];
                Object.entries(data).forEach(([dateKey, dateVal]) => {
                    if (dateVal && typeof dateVal === 'object') {
                        Object.entries(dateVal).forEach(([meetId, meetVal]) => {
                            if (meetVal && typeof meetVal === 'object') {
                                if (meetVal.schemeName) {
                                    list.push({ id: meetId, ...meetVal });
                                } else {
                                    Object.entries(meetVal).forEach(([workId, workData]) => {
                                        list.push({ id: workId, ...workData });
                                    });
                                }
                            }
                        });
                    }
                });

                list = list.filter(work => {
                    const matchesTaluka = selectedTaluka ? work.taluka === selectedTaluka : true;
                    const matchesSearch = searchTerm ?
                        work.workName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        work.workNo?.toString().includes(searchTerm) : true;
                    // Filtering for Sube (Engineer) works as per title "सु.बे. यादी"
                    const isSube = work.sharedwork === 'सुबे';
                    return matchesTaluka && matchesSearch && isSube;
                });
                
                setWorks(list);
            } else {
                setWorks([]);
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        fetchWorks();
    }, []);

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-[#f8f9fa] flex flex-col ">
                {/* Header Section */}
                <div className="px-6 py-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate(-1)}
                            className="p-2.5 bg-white rounded-xl shadow-sm border border-gray-100 text-gray-500 hover:text-indigo-900 transition active:scale-95 flex items-center justify-center"
                        >
                            <FaArrowLeft />
                        </button>
                        <h1 className="text-xl font-medium text-gray-700">सु.बे. यादी</h1>
                    </div>
                    <div className="flex items-center text-sm font-medium text-gray-500 gap-2">
                        <span>सांगली जिल्हा परिषद</span>
                        <span>/</span>
                        <span className="text-gray-600 font-semibold">सु.बे. यादी</span>
                    </div>
                </div>

                <div className="px-6 pb-12">
                    <div className="max-w-[100%] mx-auto bg-white rounded-lg shadow-sm border border-gray-200 p-8">

                        {/* Filter Section */}
                        <div className="mb-8 flex flex-col gap-3">
                            <label className="text-sm font-bold text-gray-700">
                                तालुका निवडा <span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center gap-4">
                                <select
                                    value={selectedTaluka}
                                    onChange={(e) => setSelectedTaluka(e.target.value)}
                                    className="w-full md:w-64 border border-gray-300 rounded px-4 py-2 text-sm outline-none text-gray-500 focus:ring-1 focus:ring-blue-400"
                                >
                                    <option value="">तालुका निवडा</option>
                                    {talukas.map((t, idx) => (
                                        <option key={idx} value={t}>{t}</option>
                                    ))}
                                </select>
                                <button
                                    onClick={fetchWorks}
                                    className="bg-[#5e72e4] hover:bg-[#4a5ed1] text-white px-6 py-2 rounded text-sm font-semibold transition shadow-md"
                                >
                                    Search
                                </button>
                            </div>
                        </div>

                        {/* Table Controls */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
                            <div className="flex items-center rounded overflow-hidden shadow-sm border border-gray-300">
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-xs font-semibold border-r border-gray-500 transition-colors">Copy</button>
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-xs font-semibold border-r border-gray-500 transition-colors">Excel</button>
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-xs font-semibold transition-colors">Print</button>
                            </div>

                            <div className="flex items-center gap-2">
                                <label className="text-sm font-medium text-gray-600">Search:</label>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="border border-gray-300 rounded px-3 py-1 text-sm outline-none focus:ring-1 focus:ring-blue-400"
                                />
                            </div>
                        </div>

                        {/* Data Table */}
                        <div className="overflow-x-auto border border-gray-200 rounded">
                            <table className="w-full text-left text-[13px] border-collapse">
                                <thead>
                                    {/* Multi-level Headers as per image */}
                                    <tr className="bg-white border-b border-gray-200">
                                        <th colSpan="11" className="px-4 py-3 text-center font-bold text-gray-700">बांधकाम उपविभाग पंचायत समिती</th>
                                    </tr>
                                    <tr className="bg-white border-b border-gray-200">
                                        <th colSpan="6" className="px-4 py-3 text-center font-bold text-gray-700 border-r border-gray-200">जिल्हा परिषद काम वाटप समिती पुढे शिफारस करावयाच्या यादी दि.</th>
                                        <th colSpan="5" className="px-4 py-3 text-center font-bold text-gray-700">रोजी घ्यावयाची कामे</th>
                                    </tr>
                                    <tr className="bg-[#f2f4f6] text-gray-700 font-bold border-b border-gray-200 divide-x divide-gray-300">
                                        <th className="px-3 py-3 w-16">अ.क्र <span className="text-[9px] ml-1">↑↓</span></th>
                                        <th className="px-3 py-3 w-20">वर्क नंबर <span className="text-[9px] ml-1">↑↓</span></th>
                                        <th className="px-3 py-3">तालुका <span className="text-[9px] ml-1">↑↓</span></th>
                                        <th className="px-3 py-3 min-w-[200px]">कामाचे नाव <span className="text-[9px] ml-1">↑↓</span></th>
                                        <th className="px-3 py-3">कामाची मुदत (महिने) <span className="text-[9px] ml-1">↑↓</span></th>
                                        <th className="px-3 py-3">प्रशासकीय मंजुरी क्र. व दिनांक <span className="text-[9px] ml-1">↑↓</span></th>
                                        <th className="px-3 py-3">तांत्रिक मंजुरी क्र. व दिनांक <span className="text-[9px] ml-1">↑↓</span></th>
                                        <th className="px-3 py-3">र.रु. (लाखात) <span className="text-[9px] ml-1">↑↓</span></th>
                                        <th className="px-3 py-3 min-w-[250px]">लेखाशिर्षक / योजनेचे नाव <span className="text-[9px] ml-1">↑↓</span></th>
                                        <th className="px-3 py-3">शेरा <span className="text-[9px] ml-1">↑↓</span></th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {loading ? (
                                        <tr><td colSpan="11" className="text-center py-10 text-gray-400">Loading...</td></tr>
                                    ) : works.length > 0 ? (
                                        works.map((item, index) => (
                                            <tr key={item.id} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'} hover:bg-gray-100/50 divide-x divide-gray-200`}>
                                                <td className="px-3 py-4 text-center font-medium">{index + 1}</td>
                                                <td className="px-3 py-4 font-medium text-gray-800">{item.workNumber || item.workNo || item['वर्क नंबर']}</td>
                                                <td className="px-3 py-4">{item.taluka}</td>
                                                <td className="px-3 py-4 font-medium text-[#344767]">{item.workName}</td>
                                                <td className="px-3 py-4">{item.completionPeriod || '-'}</td>
                                                <td className="px-3 py-4 text-xs">
                                                    {item.inwardNo || '-'} <br/> {item.inwardDate || item.date || ''}
                                                </td>
                                                <td className="px-3 py-4 text-xs">{item.technicalApprovalOrderNo || '-'}</td>
                                                <td className="px-3 py-4 font-bold text-gray-800">{item.tenderAmount || item.amount || '-'}</td>
                                                <td className="px-3 py-4 text-gray-600 leading-snug text-xs">
                                                    {item.budgetHead ? `${item.budgetHead} / ` : ''} 
                                                    {item.schemeName || '-'}
                                                </td>
                                                <td className="px-3 py-4 text-xs">{item.zpRemark || item.remark || '-'}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="px-6 py-12 text-center text-gray-500 font-medium italic">
                                                No data available in table
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination Section */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mt-6 text-sm text-gray-600 font-medium">
                            <p>Showing {works.length > 0 ? 1 : 0} to {works.length} of {works.length} entries</p>
                            <div className="flex shadow-sm rounded-md overflow-hidden border border-gray-300">
                                <button className="px-4 py-1.5 bg-white hover:bg-gray-50 border-r border-gray-300 transition-colors text-gray-500">Previous</button>
                                <button className="px-4 py-1.5 bg-indigo-600 text-white font-bold">1</button>
                                <button className="px-4 py-1.5 bg-white hover:bg-gray-50 border-l border-gray-300 transition-colors text-gray-500">Next</button>
                            </div>
                        </div>

                        {/* Bottom Print Button */}
                        <div className="mt-8 flex justify-center">
                            <button className="bg-[#5e72e4] hover:bg-[#4a5ed1] text-white px-8 py-2.5 rounded shadow-lg font-bold text-sm transition-transform active:scale-95">
                                Print
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </InchargeLayout>
    );
};

export default SubeShifarasList;
